module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c(_vm.currentView, {
    tag: "component",
    attrs: {
      "options": _vm.options
    },
    on: {
      "changeToLogin": _vm.change,
      "changeModule": _vm.changeModule
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "g-hd"
  }, [_c('h1', [_vm._v("安全验证")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7ec980be"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Verify.vue
// module id = 520
// module chunks = 1